import { render, staticRenderFns } from "./Slide3.vue?vue&type=template&id=153aabde&scoped=true&"
import script from "./Slide3.vue?vue&type=script&lang=js&"
export * from "./Slide3.vue?vue&type=script&lang=js&"
import style0 from "./Slide3.vue?vue&type=style&index=0&id=153aabde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153aabde",
  null
  
)

export default component.exports